import type { User } from '@awork/features/user/models/user.model'
import type { AccessLevels } from '@awork/features/workspace/models/permissions.model'

interface IDocumentContributor {
  id: string
  accessLevel: AccessLevels
  firstName: string
  hasImage: boolean
  isDeactivated: boolean
  userId: string
  user?: User
  inheritedDocumentContributor?: { accessLevel: AccessLevels; documentId: string }
  inheritedFromDocumentContributorId?: string
}

/**
 * The document contributor model
 */
export class DocumentContributor implements IDocumentContributor {
  id: string
  accessLevel: AccessLevels
  firstName: string
  hasImage: boolean
  isDeactivated: boolean
  userId: string
  user?: User
  inheritedDocumentContributor?: { accessLevel: AccessLevels; documentId: string }
  inheritedFromDocumentContributorId?: string

  constructor(documentContributor: Partial<IDocumentContributor>) {
    Object.assign(this, documentContributor)
  }
}
